var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myChart",attrs:{"id":_vm.parent_id}},[_c('canvas',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.chart_id}})])}
var staticRenderFns = []

export { render, staticRenderFns }